"use client";
import { BMPrimitives } from "@traveloka/district-bloom";
import { ReactNode } from "react";
import { Image, Pressable, StyleSheet } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import { CTV_COMPACT_WHITE_LOGO } from "../../../../assets/traveloka-for-corporates-compact-white";
import BMView from "../../../../components/View/BMView";

const MIN_BACKGROUND_HEIGHT = 196; // Default height for the background image

type Props = {
  handleRedirectLogo(): void;
  ActionComponents: ReactNode[];
  backgroundBorderRadius?: number;
  backgroundHeight?: number;
};

export default function MobileGenericHeader(props: Props) {
  const {
    handleRedirectLogo,
    ActionComponents,
    backgroundBorderRadius,
    backgroundHeight = MIN_BACKGROUND_HEIGHT,
  } = props;

  return (
    <BMView style={styles.container}>
      <BMView align="center" justify="between" row style={styles.header}>
        <Pressable onPress={handleRedirectLogo}>
          <Image
            source={{ uri: CTV_COMPACT_WHITE_LOGO }}
            style={styles.ctvLogo}
          />
        </Pressable>
        <BMView spacing="md" row>
          {ActionComponents}
        </BMView>
      </BMView>
      <LinearGradient
        style={[
          styles.image,
          {
            borderBottomRightRadius: backgroundBorderRadius,
            borderBottomLeftRadius: backgroundBorderRadius,
            height: backgroundHeight,
          },
        ]}
        colors={["#0A9AF2", "#06598C"]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
      />
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
  },
  header: {
    paddingHorizontal: BMPrimitives.BMSize.md,
    paddingVertical: 10,
    zIndex: 2,
  },
  ctvLogo: {
    width: 133,
    height: 20,
  },
  image: {
    position: "absolute",
    zIndex: -1,
    width: "100%",
  },
});
